export default __webpack_public_path__ + "static/media/LogoBlack.1ada7a22.png";